import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import { AuthUser } from "~/types";


interface UserAvatarProps {
  user: Pick<AuthUser, "name" | "email" | "image" | "role">;
  size?: number;
  showWarning?: boolean;
}

export default function UserAvatar({
  user,
  size = 36,
  showWarning = false,
}: UserAvatarProps) {
  const initial =
    user.name?.charAt(0).toUpperCase() ||
    user.email?.charAt(0).toUpperCase() ||
    "?";

  const isAdmin = user.role === "admin";

  const avatar = (
    <Avatar
      src={user.image || undefined}
      alt={user.name || user.email || "Fotografia ta"}
      sx={{
        bgcolor: "primary.main",
        width: size,
        height: size,
        fontSize: size * 0.45,
        fontWeight: "bold",
        ...(isAdmin && {
          border: "1px solid",
          borderColor: "secondary.main",
        }),
      }}
    >
      {initial}
    </Avatar>
  );

  if (showWarning) {
    return (
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        badgeContent={
          <WarningAmberIcon
            sx={{
              width: size * 0.6,
              height: size * 0.6,
              bgcolor: "warning.main",
              color: "warning.contrastText",
              borderRadius: "50%",
              padding: "2px",
            }}
          />
        }
      >
        {avatar}
      </Badge>
    );
  }

  return avatar;
}
